import { Component, Input, OnInit } from '@angular/core';
import { ReassessmentEnum, ScoresInput } from 'app/API.service';

@Component({
  selector: 'cygov-entity-progress-bars',
  templateUrl: './entity-progress-bars.component.html',
  styleUrls: ['./entity-progress-bars.component.scss'],
  standalone: false,
})
export class EntityProgressBarsComponent implements OnInit {
  @Input() scores: ScoresInput;
  @Input() height: number;
  @Input() horizontalView = false;
  @Input() isParticipant = false;
  @Input() showReassessmentScores = ReassessmentEnum.NOT_INITIATED;
  @Input() archiveMode = false;
  @Input() isBeecher: boolean = false;
  reassessmentEnum = ReassessmentEnum;

  displayBeecherWizardReassessment: boolean = false;

  constructor() {}

  ngOnInit(): void {
    if (!this.height) {
      this.height = 20;
    }
    this.displayBeecherWizardReassessment = this.checkIfShowBeecherWizardReassessment();
  }

  private checkIfShowBeecherWizardReassessment(): boolean {
    if (this.isBeecher && this.showReassessmentScores === ReassessmentEnum.IN_PROGRESS) {
      return true;
    }
    return false;
  }
}
